/* 团队项目邀请成员 弹框 */
<template>
  <div class="add-members">
    <z-dialog @close="closeDialog" :title="title" @submit="submit">
      <div class="add-members-contenet">
        <div class="top">
          <Tabs>
            <TabPane label="链接邀请">
              <div class="link">
                <p class="title">请发送链接给需要邀请的成员，成员加入住逻辑后，需企业主管理员审批</p>
                <Row :gutter="10" type="flex" justify="start">
                  <Col span="20" class="input">
                    <Input v-model="copyLink" disabled style="width: 470px;height:40px;" />
                  </Col>
                  <Col span="4">
                    <Button
                      :data-clipboard-text="copyLink"
                      class="copy"
                      @click="copyLinkHandle"
                      :disabled="!single1"
                      long
                      type="primary"
                    >复制</Button>
                  </Col>
                </Row>
                <p class="time">
                  <span>{{countdown}}</span>
                  <Button type="text" @click="reloadUpload">重新生成</Button>
                </p>
                <p style="margin-top:50px;">
                  <Checkbox v-model="single1">“点击完成”代表授权该用户代表“住逻辑斑斓信息科技”在住逻辑平台开通电子签约及相关的企业服务。</Checkbox>
                  <span class="agreement">
                    <a target="_blank" href="https://oss.zhulogic.com/doc/20190514.doc">预览授权服务协议</a>
                  </span>
                </p>
              </div>
            </TabPane>
            <TabPane label="通过手机号添加" name="name2">
              <div class="phone">
                <p class="title">请输入成员手机号添加至项目</p>
                <Row :gutter="10" type="flex" justify="start">
                  <Col span="24">
                    <Input v-model="phone" :maxlength="15" placeholder="请输入手机号" />
                  </Col>
                </Row>
                <p style="margin-top:50px;">
                  <Checkbox v-model="single2">“点击完成”代表授权该用户代表“住逻辑斑斓信息科技”在住逻辑平台开通电子签约及相关的企业服务。</Checkbox>
                  <span class="agreement">
                    <a target="_blank" href="https://oss.zhulogic.com/doc/20190514.doc">预览授权服务协议</a>
                  </span>
                </p>
              </div>
              <div class="btn" style="margin-top:200px">
                <Button
                  :disabled="!single2"
                  @click.native="addPhoneHandle"
                  type="primary"
                  :loading="phone_loading"
                >&nbsp;&nbsp;&nbsp;确定&nbsp;&nbsp;&nbsp;</Button>
              </div>
            </TabPane>
            <TabPane label="从已有项目复制" name="name3">
              <div class="old-copy">
                <Row type="flex" justify="start" align="middle">
                  <Col class="title" span="4">选择项目</Col>
                  <Col span="20">
                    <Select
                      v-model="oldProject"
                      v-if="teamProject && teamProject.length > 0"
                      @on-change="changeHandle"
                      style="width:200px"
                    >
                      <Option
                        v-for="item in teamProject"
                        :value="item.projectId"
                        :key="item.projectId"
                      >{{ item.projectName }}</Option>
                    </Select>
                  </Col>
                </Row>
                <div class="members">
                  <p
                    v-if="projectIdGroupList && projectIdGroupList.length > 0"
                    class="name"
                  >请选择成员（{{social.length}}/{{projectIdGroupList.length}}）</p>
                  <CheckboxGroup
                    v-if="projectIdGroupList && projectIdGroupList.length > 0"
                    v-model="social"
                    @on-change="chioceGroup"
                  >
                    <Checkbox
                      v-for="(item, index) in projectIdGroupList"
                      :key="index"
                      :label="item.id"
                    >
                      <Avatar
                        icon="ios-person"
                        size="small"
                        :src="item.avatarFile && ossPrefix + item.avatarFile.key"
                      />
                      <span class="realname">{{item.loginName}}（{{item.realName}}）</span>
                    </Checkbox>
                  </CheckboxGroup>
                  <p
                    class="empty-info"
                    v-if="!projectIdGroupList || projectIdGroupList.length === 0"
                  >暂无成员</p>
                </div>
                <p class="bottom">
                  更多成员信息请在
                  <span @click="hrefTeamProject">项目成员管理</span> 设置
                </p>
              </div>
              <div class="btn">
                <Button
                  :disabled="social.length === 0"
                  :loading="copy_loading"
                  @click.native="submit"
                  type="primary"
                >&nbsp;&nbsp;&nbsp;保存&nbsp;&nbsp;&nbsp;</Button>
              </div>
            </TabPane>
          </Tabs>
        </div>
      </div>
    </z-dialog>
  </div>
</template>

<script>
import dialogs from "../../mixins/dialogs.js";
import ZDialog from "./dialog";
import { findComponentDownward, randomString } from "../../utils/assist.js";
import Clipboard from "clipboard";
import { clearTimeout, setInterval, clearInterval } from "timers";
export default {
  name: "ZAddMembers",
  mixins: [dialogs],
  data() {
    return {
      single1: true,
      single2: true,
      phone: "",
      oldProject: "1",
      social: [],
      countdown: "",
      timerDown: true,
      lists: [
        {
          value: "1",
          label: "New York"
        },
        {
          value: "2",
          label: "London"
        },
        {
          value: "3",
          label: "Sydney"
        }
      ],
      userProjectTeam: []
    };
  },
  provide() {
    return {
      app: this
    };
  },
  props: {
    ossPrefix: {
      type: String,
      default: ""
    },
    projectIdGroupList: {
      type: [Array, String],
      default: ""
    },
    teamProject: {
      type: [Array, String],
      default: ""
    },
    copy_loading: {
      type: Boolean,
      default: false
    },
    phone_loading: {
      type: Boolean,
      default: false
    },
    validTime: {
      type: [String, Number],
      default: ""
    },
    copyLink: {
      type: String,
      default: ""
    },
    display: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    }
  },
  components: { ZDialog },
  methods: {
    closeDialog() {
      this.$emit("close");
    },
    /* copy */
    copyLinkHandle() {
      let clipboard = new Clipboard(".copy");
      setTimeout(() => {
        this.$Message.success("成功复制到剪切板");
      }, 300);
    },
    /* 通过手机号添加 */
    addPhoneHandle() {
      if (!/^1[3456789]\d{9}$/.test(this.phone)) {
        this.$Message.error("请输入正确的电话号码");
        return false;
      }
      this.$emit("addPhone", this.phone);
    },

    /* 选择之后显示成员 */
    changeHandle(val) {
      this.social = [];
      this.$emit("changeOldProject", val);
    },

    /* 选择项目成员复制 */
    chioceGroup(val) {
      this.social;
    },
    /* 保存 */
    submit() {
      let userProjectTeam = [];
      this.social.forEach((item, index) => {
        let label = this.projectIdGroupList.filter(
          params => item === params.id
        )[0];
        let obj = {
          projectId: label.projectId,
          userId: label.id
        };
        userProjectTeam.push(obj);
      });
      this.$emit("submitCopy", { userProjectTeam: userProjectTeam });
    },

    addZero(i) {
      if (i < 10) {
        i = "0" + i;
      }
      return i;
    },

    /* 倒计时 */
    showtime() {
      var nowtime = new Date();
      var endtime = this.validTime;
      var lefttime = parseInt((endtime - nowtime) / 1000);
      var d = parseInt(lefttime / (24 * 60 * 60));
      var h = parseInt((lefttime / (60 * 60)) % 24);
      var m = parseInt((lefttime / 60) % 60);
      var s = parseInt(lefttime % 60);
      h = this.addZero(h);
      m = this.addZero(m);
      s = this.addZero(s);
      this.countdown = d + "天" + h + ":" + m + ":" + s;
      if (lefttime <= 0) {
        this.timerDown = false;
        this.countdown = "链接失效";
        clearInterval(this.timer);
      }
    },
    reloadUpload() {
      /* 重新生成 */
      this.timer = setInterval(this.showtime, 1000);
      this.$emit("reload");
    },

    /* 点击项目成员管理 */
    hrefTeamProject() {
      this.$emit("hrefTeam");
    }
  },
  mounted() {
    const Dialog = findComponentDownward(this, "ZDialog");
    if (Dialog) {
      this.diaologDom = Dialog;
    }
    this.timer = setInterval(this.showtime, 1000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  watch: {
    display: function() {
      console.log(this.display)
      if (this.display) {
        this.diaologDom.op();
      } else {
        this.diaologDom.close();
      }
    },
    copy_loading: function() {
      if (!this.copy_loading) {
        this.social = [];
      }
    }
  }
};
</script>

